import { MouseEvent } from 'react';

type OnClickEvent<E = Element> = (event: MouseEvent<E>) => void;

export function stopEventBubbling<E = Element>(
  onClick: OnClickEvent<E>,
): OnClickEvent<E> {
  return (event: MouseEvent<E>): void => {
    event.stopPropagation();
    onClick(event);
  };
}
